'use client'

import { Button } from '@vinted/web-ui'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { useSession } from '@marketplace-web/shared/session-data'
import { urlWithParams } from '@marketplace-web/browser/url-util'
import { useRefUrl } from '@marketplace-web/ref-url/ref-url-feature'

import { ItemPageMarkAsSoldButtonPluginModel } from './types'
import { MARK_ITEM_AS_SOLD_URL } from '../../constants/routes'

type Props = {
  data: ItemPageMarkAsSoldButtonPluginModel | undefined
}

const ItemPageMarkAsSoldButtonPlugin = ({ data }: Props) => {
  const translate = useTranslate()
  const refUrl = useRefUrl()
  const { user: currentUser } = useSession()

  if (!data) return null

  const { itemId, transactionPermitted, isClosed, userId } = data
  const isViewingOwnItem = userId === currentUser?.id

  if (!isViewingOwnItem) return null
  if (!(transactionPermitted && !isClosed)) return null

  const markAsSoldUrl = urlWithParams(MARK_ITEM_AS_SOLD_URL(itemId), {
    ref_url: refUrl,
  })

  return (
    <Button
      text={translate('item.actions.mark_as_sold')}
      url={markAsSoldUrl}
      size="medium"
      testId="mark-as-sold-button"
    />
  )
}

export default ItemPageMarkAsSoldButtonPlugin
